import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackPopupAgree, trackPopupClose, trackPopupShow } from './tracking';
// eslint-disable-next-line import/no-restricted-paths
import { setLocationCookies } from '../../../browser/utils/setLocationCookies';
import { RegionSelectCall } from '../../components/RegionSelectCall';
import { selectGeo } from '../../selectors/geo';
import { selectPageType } from '../../selectors/page';
import { useApplicationContext } from '../../utils/applicationContext';

export function RegionSelectCallContainer() {
  const {
    config,
    custom: { isRegionSelected },
    eventQueue,
  } = useApplicationContext();

  const isRegionSelectCallEnabled = config.get<boolean>('header-frontend.regionSelectCall.Enabled') ?? false;

  const geo = useSelector(selectGeo);

  const page = useSelector(selectPageType);

  const [opened, setOpened] = React.useState(!isRegionSelected);

  const handleClose = useEventCallback(() => {
    trackPopupClose(geo.cityName);
    setOpened(false);
  });

  const handleAgree = useEventCallback(() => {
    setLocationCookies(geo);
    trackPopupAgree(geo.cityName);
    setOpened(false);
  });

  const handleRegionChange = useEventCallback(() => {
    eventQueue.emit('geo-location-popup-reporting.v1.open');
  });

  const handlePopupShow = useEventCallback(() => {
    trackPopupShow(geo.cityName);
  });

  if (!isRegionSelectCallEnabled || !opened || page !== 'main') {
    return null;
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={handlePopupShow} wrapper={false}>
      <RegionSelectCall
        regionName={geo.cityName}
        onClose={handleClose}
        onAgree={handleAgree}
        onRegionChange={handleRegionChange}
      />
    </ActionAfterViewObserver>
  );
}
